<template>
  <div
    class="ba-flex ba-flex-col ba-items-center ba-m-auto ba-text-white ba-w-full"
    :class="{'ba-p-4': !noPadding}"
  >
    <figure v-if="logo" href="/" class="identity__logo ba-text-center ba-w-full ba-max-w-76">
      <img class="ba-mb-4 ba-w-full ba-inline" src="/img/brand/white/logo.svg" alt="Logo" />
    </figure>
    <div class="splash-screen__msg ba-w-full ba-text-center">
      <h4 class="ba-text-center">
        <span class="far fa-spinner fa-spin" :class="sizeClass" />
      </h4>
    </div>
    <span v-if="hasDefaultSlot" class="ba-mt-4">
      <slot></slot>
    </span>
    <span v-else-if="withDefault" class="ba-mt-4">Информация загружается…</span>
  </div>
</template>

<script>
export default {
  name: "vis-loading",
  props: {
    size: {
      type: String,
      default: "",
      validator: (v) => ["xs", "sm", "md", "lg", ""].indexOf(v) !== -1
    },
    logo: {
      type: Boolean,
      default: false
    },
    withDefault: {
      type: Boolean,
      default: false
    },
    noPadding: {
      type: Boolean,
      default: false
    },
    color: {
      type: String,
      default: "ba-text-primary"
    }
  },
  computed: {
    sizeClass() {
      switch (this.size) {
        case "lg":
          return "ba-text-6xl";
        case "sm":
          return "ba-text-3xl";
        case "xs":
          return "ba-text-xl";
        case "md":
          return "ba-text-5xl";
        default:
          return "";
      }
    },
    hasDefaultSlot() {
      return !!this.$slots.default;
    }
  }
};
</script>
